import {BaseService} from "@/core/services/BaseService";

class MasterProviderService extends BaseService<any> {
  endpoint = "/master-provider";
}

export default new MasterProviderService();